import { combineReducers } from 'redux';
import { fork, all } from 'redux-saga/effects';
import application from './application';
import table, { tableSaga } from '@oscar/table';
import form, { formSaga } from '@oscar/form';

export const rootReducer = combineReducers({
  application,
  table,
  form,
});

export function* rootSaga() {
  yield all([fork(tableSaga)]);
  yield all([fork(formSaga)]);
}
